import WishlistComponent from '../../components/Wishlist';

export default function Wishlist () {
  return <WishlistComponent fullscreen />
}